<template>
  <v-container grid-list-md text-xs-center>
    <TableCancleCourse />
    <CourseDetial />
  </v-container>
</template>

<script>
import TableCancleCourse from "../components/Tables/TableCancleCourse";
import CourseDetial from "../components/CourseDetial";

export default {
  components: {
    TableCancleCourse,
    CourseDetial,
  },
  mounted() {
    this.$store.dispatch("getCancleCourse");
  },
};
</script>
